import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  semiBold: {
    fontWeight: 600,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    '& .MuiPaper-root': {
      elevation: 3,
    },
    maxWidth: '100%',
  },
  title: {
    marginLeft: '0px',
    marginBottom: '0px',
    marginTop: '1rem',
    paddingLeft: '0px',
  },
  loading: {
    color: theme.palette.primary.main,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '200px',
  },
  backButtonQuestionResponse: {
    width: '80px',
    paddingLeft: '0px',
    color: theme.palette.secondary.middleGray,
    '& span': {
      fontSize: '13px',
    },
  },
  tablesContainer: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  tableWrapper: {
    flex: 1,
    minWidth: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& > .MuiTableContainer-root': {
      flex: 1,
    },
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
  table: {
    minWidth: 0,
    width: '100%',
  },
  highlightMeasurementTime: {
    color: '#d32f2f',
    fontWeight: 600,
  },
  taskLink: {
    textDecoration: 'none',
    color: '#22617B',
    fontWeight: 600,
  },
}));

export default useStyles;
